<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.spareka.reparation_en_autonomie')}}
        </h1>    
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <template v-if="selected.end">{{$t('form.spareka.solution_trouvee')}}</template>
                    <template v-if="!selected.end">{{$t('form.spareka.solution_pas_trouvee')}}</template>
                </template>
            </template>
            <template v-slot:open>
                <div id="spareka-diag"></div>
                <div class="flex justify-center mt-2">
                    <div class="p-2">
                        <button @click="end({end: false})" class="px-5 py-2 duration-200 bg-yellow-400 w-100 btn hover:bg-yellow-500 rounded-xl">
                            {{$t('form.spareka.solution_pas_trouvee')}}
                            <i class="ml-1 fas fa-times"></i>
                        </button>
                    </div>
                    <div class="p-2">
                        <button @click="end({end: true})" class="px-5 py-2 text-white duration-200 bg-green-600 w-100 btn hover:bg-green-700 rounded-xl">
                            {{$t('form.spareka.solution_trouvee')}}
                            <i class="ml-1 fas fa-check"></i>
                        </button>
                    </div>
                </div>
            </template>
        </sav-fold-card>
    </div>
</template>



<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'spareka',
    extends: FormCardExtension,

    data() {
        return {
            diag: null,
            brand: null,
            reference: null,
        }
    },

    methods: {
        init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextBlock()
            }

            // Init tchat
            if (this.$formTool.getFormData('spareka-keyword')) {
                this.diag = this.$formTool.getFormData('spareka-keyword')
            }

            this.reference = this.$formTool.getFormData('device')[0].value['Modele']
            this.initSpareka()
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            this.nextBlock = this.getNextBlock()
        },

        getNextBlock() {
            if (this.selected && this.selected.end) {
                return this.$formTool.blockData(this.$options.name).next.end
            } else {
                return this.$formTool.blockData(this.$options.name).next.continue
            }
        },

        initSpareka() {
            (function (d,a) {
                var e = encodeURIComponent, c = Object.keys(a).map(function (k) { return e(k) + '=' + e(a[k]);}).join('&'),
                j = d.createElement('script'), f = d.getElementsByTagName('head')[0]; j.async = 1;
                j.src = 'https://api.spareka.fr/widget/diag.js?'+c; f.appendChild(j);
            }(document, {
                api_key:               '756b2555e7ad77af093179edb0495e2f6c3e3e939da4bdd14f080405907965bd',
                language:              'fr',
                width:                 '100%',
                height:                '64vh',
                diag:                  this.diag,
                brand:                 this.brand,
                reference:             this.reference,
            }));
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/tchat/SparekaTchatCard.vue